import React from 'react';
import { Row, Col, FormControl, FormGroup, Checkbox, Radio } from 'react-bootstrap';

class NuovoCliente extends React.Component {
  render() {
  	return (
      <Row className="noNegativeMargin">      		        
        <Col xs={12}>
          <FormGroup controlId="FlagClienteNuovo" name="FlagClienteNuovo">
            <Radio name="FlagClienteNuovo" inline value="true" id="FlagClienteNuovoSi" data-caption="Cliente nuovo" data-separator="%%%Cliente" required 
              defaultChecked={(this.props.editMode)? this.props.panNuovoCliente['FlagClienteNuovo'] === 'true': ''} data-parse="bool">
              Cliente nuovo
            </Radio>
            <Radio name="FlagClienteNuovo" inline value="false" id="FlagClienteNuovoNo" data-caption="Già cliente (offerta famiglia)" data-separator="%%%Cliente" required 
              defaultChecked={(this.props.editMode)? this.props.panNuovoCliente['FlagClienteNuovo'] === 'false': ''} data-parse="bool">
              Già cliente (offerta famiglia)
            </Radio>
          </FormGroup>
        </Col>

        <Col xs={12} lg={6}>
          <label htmlFor="ProvenienzaCliente">Provenienza cliente</label>
          <FormGroup>
            <FormControl
                componentClass="select" placeholder=""
                id="ProvenienzaCliente" name="ProvenienzaCliente"
                data-caption="Provenienza cliente" data-parse="select-label"
                defaultValue={(this.props.editMode)? this.props.panNuovoCliente['ProvenienzaCliente']: ''} required>
                  <option value="">Seleziona</option>
                  <option value="A">Visita cliente</option>
                  <option value="B">Visita buono soggiorno</option>
                  <option value="E">Evento associativo o wellness</option>
                  <option value="S">Visita sito Imperial</option>
                  <option value="R">Rinfresco</option>
                  <option value="V">Rientro voucher</option>
            </FormControl>
          </FormGroup>
        </Col>
      </Row>	        		  
  	);
  }
}

export default NuovoCliente;



// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelCliente/NuovoCliente.js